import i18next from 'i18next'
import * as React from 'react'
import { any, fromJSX, StandardLocalWidget } from 'widgets-for-react'
import { FormControls } from '../../utils/forms'
import { DataLayer, PIIData } from '../../utils/datalayer'
import { ComponentDidMount } from '../../utils/lifecycleMethods'
import { camelize } from '../../utils/utils'
import { emptyJob, Job, JobState, jobStateUpdaters } from './jobState'
import { singleValidatorResultBuilders } from '../../validator/validator'


const translateJob = (title: string) => i18next.t(`jobs:${camelize(title)}`)

export const jobWidget =
  (
    availableJobs: Array<Job>,
    showValidation: boolean = true,
    readonly: boolean = false,
    inFlow: 'trial' | 'upgrade' | 'none' = 'none',
    isStudent: boolean = false,
    suppressHotjar: boolean,
    piiData?: PIIData
  ): StandardLocalWidget<JobState> =>
  (currentState) => {
    const selected =
      (isStudent
        ? availableJobs.find((job) => job?.Title == 'Leerling')
        : availableJobs.find((job) => job.Id == currentState.input.Id)) ||
      emptyJob

    return any([
      currentState.validator
        .widget()
        .map(jobStateUpdaters.validation),
      fromJSX((setState) => {
        if (
          isStudent &&
          currentState.input.Id === undefined &&
          selected.Id !== undefined
        ) {
          setState((s) => ({ ...s, input: selected }))
        }
        return (
          <FormControls.ShowIf
            condition={
              inFlow != 'upgrade' &&
              (!readonly || currentState.input.Id != undefined) &&
              !isStudent
            }
          >
            <ComponentDidMount
              onMount={() => {
                if (selected.Title !== undefined) {
                  if (inFlow == 'trial') {
                    DataLayer.changeTrialFormValue(
                      'jobTitle',
                      translateJob(selected.Title)
                    )
                  } else if (inFlow == 'upgrade') {
                    DataLayer.upgradeFlowStep2(
                      'jobTitle',
                      piiData,
                      translateJob(selected.Title)
                    )
                  }
                }
              }}
            />
            <FormControls.FormSelectInGroup
              controlId="jobChoice"
              label={i18next.t('auth:signupJob')}
              readOnly={readonly}
              required={true}
              value={selected.Id?.toString() || ''}
              onChange={(newValue) => {
                const newJob =
                  availableJobs.find(
                    (job) => job.Id?.toString() == newValue
                  ) || emptyJob
                setState(jobStateUpdaters.input(() => newJob))
                if (newJob.Title !== undefined) {
                  if (inFlow == 'trial')
                    DataLayer.changeTrialFormValue(
                      'jobTitle',
                      translateJob(newJob.Title)
                    )
                  if (inFlow == 'upgrade')
                    DataLayer.upgradeFlowStep2('jobTitle', piiData, newValue)
                }
              }}
              validation={
                showValidation
                  ? (currentState.validatorResult.path('Id').kind !== 'passed')
                    ? singleValidatorResultBuilders.failed(
                      'selectedJob',
                      i18next.t("auth:signupJobError")
                    )
                    : singleValidatorResultBuilders.passed('selectedJob')
                  : undefined
              }
              suppressHotjar={suppressHotjar}
            >
              {[
                <option value="" disabled={true}>
                  {i18next.t('auth:selectPlaceholder', {
                    entity: i18next.t('subscription:Job').toLowerCase(),
                  })}
                </option>,
                ...availableJobs.map((job) =>
                  job.Title !== undefined ? (
                    <option value={job.Id?.toString()}>
                      {translateJob(job.Title)}
                    </option>
                  ) : (
                    <></>
                  )
                ),
              ]}
            </FormControls.FormSelectInGroup>
          </FormControls.ShowIf>
        )
      }),
    ])
  }
